<template>
  <div>
    <label>{{label}}</label>
    <multiselect
      v-model="selValueModel"
      :track-by="ctrlCode"
      :label="ctrlName"
      :placeholder="placeholder"
      :options="options"
      :searchable="isSearchable"
      :multiple="isMultiple"
      :allow-empty="false"
      :taggable="false"
      :loading="isInValidOptions()"
      @input="emitVal(selValueModel)"
      deselectLabel
      deselectGroupLabel
      selectLabel
      selectedLabel
    >
      <template slot="singleLabel" slot-scope="{ option }">{{ option[ctrlName] }}</template>
      <template slot="option" slot-scope="props">
        <div class="d-flex">
          <span class="txt-over-ellips w-50">{{ props.option[ctrlName] }}</span>
          <strong class="right txt-over-ellips w-50 text-right" v-if="isShowCode">{{ props.option[ctrlCode] }}</strong>
        </div>
      </template>
      <template #noResult>
                <strong >
                  {{resultEmpty}}
                </strong>
              </template>
              <template #noOptions>
                <strong >
                  {{optionEmpty}}
                </strong>
              </template>
    </multiselect>
    <!-- <CAlert v-if="alertValue" show color="danger">{{ alertValue }}</CAlert> -->
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import Logger from "../../services/logger";
import { mapGetters, mapActions } from "vuex";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../config/API_DATA";
import apiGetAirline from "../../services/apiGetAirline";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "../../util/apiValidate";
import { handleJWT, getErrorAlertValue ,OrderByList} from "../../util/util";
import BaseConfiguration from "../../config/base.js";
import { COMPONENT_NAME,ORDER } from '../../util/constants';

export default {
  name: "cAirLine",

  components: {
    Multiselect
  },
  model: {
    prop: "selValue"
  },

  props: {
    selValue: {
      type: Object | Array,
      default: []
    },
    isShowCode: {
      type: Boolean,
      default: false
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
    isSearchable: {
      type: Boolean,
      default: false
    },
    ctrlName: {
      type: String,
      default: ""
    },
    ctrlCode: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: function () {
    return this.$t("cAirline.select")
      }
    },
    isShowDefaultAirline: {
      type: Boolean,
      default: true
    },
    resultEmpty: {
     type: String,
     // default: 'No matching items found'
     default: function () {
    return this.$t("cAirline.resEmpty")
     }
   },
   optionEmpty: {
     type: String,
     default: function () {
    return this.$t("cAirline.optEmpty") }

   },
  },

  data: () => ({
    options: [],
    selected: false,
    selValueModel: {
      airline_code: null,
      airline_name: null,
      logourl: null
    },
    alertValue: null
  }),

  watch: {
    selValue(val) {
      if (val !== this.selValueModel) {
        this.selValueModel = val;
      }
    }
  },

  methods: {
    ...mapActions("sCAirLine", ["SET_ALL_AIRLINE_RES"]),

    showAlert(val) {
      this.alertValue = val;
    },
    emitVal(value) {
      this.$emit("input", value);
    },

    isInValidOptions() {
      let retValue = false;
      if (this.options && this.options.length > 0)
        //check options length
        retValue = false;
      else retValue = true;
      return retValue;
    },

    async getAirLineOptions() {
      try {
        if (this.airlineRes == null) {
          this.options = await this.getAirLineList();

          if(this.options && this.options.length > 0){
          if (!(this.selValueModel && this.selValueModel.airline_code)) {
            this.selValueModel =this.getDefaultAirline(this.options);
            this.emitVal(this.selValueModel);
          }
          }
        } else if(this.airlineRes!=null){
          
          this.options = this.airlineRes;
           if(this.options && this.options.length > 0){
          if (!(this.selValueModel && this.selValueModel.airline_code)) {
            this.selValueModel = this.getDefaultAirline(this.options);
            this.emitVal(this.selValueModel);
          }
           }
          if (BaseConfiguration.isDebug) console.log("options from store!");
        }
      } catch (err) {
        let body = Logger.buildRequest(
          "cAirLine",
          "error in getAirLineOptions",
          err.toString(),
          "getAirLineOptions",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getDefaultAirline(pOptionsList) {
      let retValue;
      try {
        if (pOptionsList != null && pOptionsList.length > 0) {
          for (let i = 0; i < pOptionsList.length; i++) {
            if(this.isShowDefaultAirline){
            if (
              pOptionsList[i].airline_code ==
              BaseConfiguration.defaultAirlineCode
            ) {
              retValue = pOptionsList[i];
              break;
            }
            }else{
              retValue = this.selValueModel;
            }
          }
        } else {
          retValue = this.selValueModel;
          throw "invalid options list";
        }
     
      } catch (err) {
        let body = Logger.buildRequest(
          "cAirLine",
          "error in getDefaultAirline",
          err.toString(),
          "getDefaultAirline",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
         return retValue;
    },

    async getAirLineList() {
      let returnValue=[];
      try {
        let airLineRequest = apiGetAirline.buildRequest();
        if (airLineRequest) {
          let airLineResponse = await apiGetAirline.getResponse(airLineRequest);

          if (VALIDATE_SUCCESS_RES(airLineResponse)) {
          
            returnValue = airLineResponse.data.data;
              this.SET_ALL_AIRLINE_RES(returnValue);
            this.showAlert(null);
          } else {
            let error = getErrorMessage(airLineResponse);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.showAlert(getErrorAlertValue(error));
            }
          }
        } else {
          throw "invalid request";
        }

        return returnValue;
      } catch (err) {
        let body = Logger.buildRequest(
          "cAirLine",
          "error in getAirLineList",
          err.toString(),
          "getAirLineList",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    getPropToSortAirlines(pAirline) {
        try {
          if(BaseConfiguration.isDebug) console.log("getPropToSortAirlines");
         if(pAirline.airline_name) {
           return pAirline.airline_name.toLowerCase();}
    
        } catch (err) {
                let body = Logger.buildRequest(
                  'cAirLine',
                  "error in getPropToSortAirlines",
                  err.toString(),
                  "getPropToSortAirlines",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          
        }, 
  },

  computed: {
    ...mapGetters("sCAirLine", {
      airlineRes: "GET_ALL_AIRLINE_RES"
    })
  },

  async created() {
    this.selValueModel = this.selValue;
    await this.getAirLineOptions();
    this.options=OrderByList(this.options,this.getPropToSortAirlines,ORDER.ASC);
    

  }
};
</script>